import { noop } from '../../../common/misc';

export const usePlaidEvents = noop;
